<div class="flex-1 overflow-y-auto overflow-x-hidden p-4 scroll-behavior-smooth" #messagesContainer>
  <div class="w-full mx-auto flex flex-column gap-3">
    @for (message of messages$ | async; track trackByMessage($index, message)) {
      <div class="flex flex-column gap-2 animation-duration-300 fadein" [ngClass]="{
        'align-self-end': message.isUser,
        'align-self-start': !message.isUser,
        'w-6': message.isUser,
        'w-11': !message.isUser
      }">
        <div class="flex align-items-center gap-2 text-xs text-600" [ngClass]="{
          'justify-content-end': message.isUser
        }">
          <div class="flex align-items-center gap-2">
            <span class="font-medium">{{ message.isUser ? ('chat.messages.you' | translate) : getAgentDisplayName(message.agentType) }}</span>
            @if (message.agentType && !message.isUser) {
              <p-tag
                [value]="getAgentTypeLabel(message.agentType)"
                severity="info"
                class="text-2xs font-semibold">
              </p-tag>
            }
            @if (message.promptType && message.isUser) {
              <p-tag
                [value]="getPromptTypeLabel(message.promptType)"
                severity="secondary"
                class="text-2xs font-medium">
              </p-tag>
            }
          </div>
          <span class="white-space-nowrap">{{ message.timestamp | date:'short' }}</span>
        </div>

        @if (message.metadata?.hasError) {
          <p-message
            severity="error"
            [text]="('chat.messages.error-prefix' | translate) + message.metadata.errorMessage"
            class="mb-2">
          </p-message>
        }

        <div class="p-3 border-round-xl text-sm line-height-3 white-space-pre-wrap word-break-break-word" [ngClass]="{
          'bg-primary text-white': message.isUser,
          'bg-white text-900 border-1 surface-border': !message.isUser,
          'border-left-3 border-red-500 bg-red-50': message.metadata?.hasError
        }" [style.border-bottom-right-radius]="message.isUser ? '0.25rem' : null" [style.border-bottom-left-radius]="!message.isUser ? '0.25rem' : null">
          @if (isJsonResponse(message.content) && !message.isUser) {
            @let jsonResponse = parseJsonResponse(message.content);

            @if (jsonResponse.reply) {
              <div class="json-reply">
                {{ jsonResponse.reply }}
              </div>
            }

            @if (jsonResponse.explanation) {
              <div class="json-explanation">
                <strong>{{ 'chat.messages.explanation' | translate }}</strong>
                <div class="explanation-content">{{ jsonResponse.explanation }}</div>
              </div>
            }

            @if (jsonResponse.plan) {
              <div class="json-plan">
                <strong>{{ 'chat.messages.plan' | translate }}</strong>
                <div class="plan-content">{{ jsonResponse.plan }}</div>
              </div>
            }

            @if (jsonResponse.code) {
              <div class="json-code-section">
                <div class="code-header">
                  <strong>{{ 'chat.messages.code' | translate }}</strong>
                  <div class="flex gap-1">
                    <p-button
                      icon="pi pi-copy"
                      (onClick)="copyCodeToClipboard(jsonResponse.code!)"
                      [pTooltip]="'chat.messages.copy-code-tooltip' | translate"
                      [text]="true"
                      size="small"
                      class="text-gray-600">
                    </p-button>
                  </div>
                </div>
                <selfai-platform-chat-code-viewer
                  [codeContent]="jsonResponse.code"
                  [language]="getLanguageFromAgentType(message.agentType)"
                  [readonly]="true"
                  (openEditor)="openCodeInEditor($event)"
                ></selfai-platform-chat-code-viewer>
              </div>
            }
          } @else {
            {{ getMessageText(message.content) }}
          }
          @if (message.isStreaming) {
            <span class="typing-indicator">▊</span>
          }
        </div>

        @if (message.metadata?.codeBlock && !message.isUser && !isJsonResponse(message.content)) {
          <selfai-platform-chat-code-viewer
            [codeContent]="message.metadata.codeBlock"
            [language]="getLanguageFromAgentType(message.agentType)"
            (openEditor)="openCodeInEditor($event)"
          ></selfai-platform-chat-code-viewer>
        }

        @if (message.data && message.isUser) {
          <p-accordion class="mt-2">
            <p-accordionTab [header]="'chat.messages.view-json-data' | translate">
              <pre class="bg-gray-50 p-3 border-1 surface-border border-round text-xs overflow-auto max-h-12rem">{{ message.data | json }}</pre>
            </p-accordionTab>
          </p-accordion>
        }
      </div>
    }

    @if (isProcessing$ | async) {
      <div class="flex align-items-center gap-3 p-3">
        <div class="flex gap-1 typing-dots">
          <span class="w-2 h-2 bg-gray-500 border-circle animation-duration-1400 animation-iteration-infinite typing-animation"></span>
          <span class="w-2 h-2 bg-gray-500 border-circle animation-duration-1400 animation-iteration-infinite typing-animation animation-delay-200"></span>
          <span class="w-2 h-2 bg-gray-500 border-circle animation-duration-1400 animation-iteration-infinite typing-animation animation-delay-400"></span>
        </div>
        <span class="text-gray-600 text-sm font-italic">{{ 'chat.messages.agent-processing' | translate }}</span>
      </div>
    }
  </div>
</div>
